import './Row.scss';
import { Container } from '@components/Component/Container/Container.js';
import DIContainer from '@components/DependencyInjectionContainer.js';
/**
 * `Row` represents a full screen width container on a form that can contain components or grids. Dont mix grids with other components in the same row.
 * It extends the `Container` class.
 */
export class Row extends Container {
    constructor(id, rootElement, dependencies = {}) {
        super(id, rootElement, dependencies);
        this.componentName = 'Row';
        this.designerDragType = 'row';
    }
    draw() {
        super.draw();
        this.rootElement.classList.add('row');
        // orders should be applied prior to draw so no need for observing those properties. 
        this.updateLayout();
        if (this.formDesignerMode) {
            this.setupForFormDesigner();
        }
    }
    setupForFormDesigner() {
        const addComponentButton = DIContainer.getInstance('IconManager').getIconElement('add');
        addComponentButton.classList.add('form-designer-add');
        this.rootElement.appendChild(addComponentButton);
        this.rootElement.classList.add('drop-target-row');
    }
    /**
     * Re-applies QStrap classes to row.
     * Call this if you make changes to order after drawing.
     *
     * @example
     * const row = form.componentGet('row1')
     * row.order_sm = 6;
     * row.updateLayout();
     */
    updateLayout() {
        // Classes to be added
        let newClassList = '';
        newClassList += this.ord('', this.order);
        newClassList += this.ord('sm', this.order_sm);
        newClassList += this.ord('md', this.order_md);
        newClassList += this.ord('lg', this.order_lg);
        newClassList += this.ord('xl', this.order_xl);
        // Get current classes and filter out col-* and order-*
        const currentClasses = this.rootElement.className.split(' ').filter(cls => !cls.startsWith('order-'));
        // Combine new classes with retained classes
        this.rootElement.className = currentClasses.join(' ') + newClassList;
    }
    // TODO: move this to a QStrap.ts utility
    /**
     * Utility function for assigning order- classes
     * @param prefix - the screen breakpoint size
     * @param order - a number
     * @private
     */
    ord(prefix, order) {
        if (!order) {
            return '';
        }
        if (prefix) {
            return ` order-${prefix}-${order}`;
        }
        return ` order-${order}`;
    }
}
Row.VERSION = '$Revision: 111642 $';
